import { __assign, __rest } from "tslib";
import React, { useRef } from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltButtonWireframe = function (props) {
    var id = props.id, disabled = props.disabled, active = props.active, type = props.type, group = props.group, children = props.children, remainingProps = __rest(props, ["id", "disabled", "active", "type", "group", "children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    var ref = useRef();
    return (React.createElement("velt-button-wireframe", __assign({ ref: ref, id: id, disabled: [true, false].includes(disabled) ? (disabled ? 'true' : 'false') : undefined, active: [true, false].includes(active) ? (active ? 'true' : 'false') : undefined, type: type, group: group }, transformedProps), children));
};
export default VeltButtonWireframe;
